import { render, staticRenderFns } from "./ScratchPadModal.vue?vue&type=template&id=379b89c4"
import script from "./ScratchPadModal.vue?vue&type=script&lang=js"
export * from "./ScratchPadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports